
































import FooterButton from "@/components/FooterButton.vue";
import { Component, Mixins } from "vue-property-decorator";
import { ContentService } from "@/service/content.service";
import { MatchHeadstartContent } from "@/models/content/match-headstart";
import CommonMixin, {
  WORKFLOW_PREFERRED_HEAD_START,
} from "@/mixins/common-mixins";
import { AppData, CareGiver } from "@/models/app-data";
import { WorkflowService } from "@/service/workflow.service";
import { Route } from "vue-router";
import PageLoader from "@/components/PageLoader.vue"

@Component({
  components: {
    FooterButton,
    PageLoader
  },
})
export default class MatchHeadstart extends Mixins(CommonMixin) {
  workflowService = new WorkflowService();
  appData = {} as AppData;
  loadDataFinished = false;
  content: MatchHeadstartContent = {} as MatchHeadstartContent;
  textDirection = 'ltr'
  isReferral = false

  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getMatchHeadStartContent();
      this.textDirection = contentService.TextDirection()
      await this.loadData();

    } catch (error) {
      this.showError(error);
    }
  }

  handleNextPageEvent(): void {
    this.$router.push({ path: "HeadstartPickPrograms" });
  }

  async loadData(): Promise<void> {
    if (this.$route?.query?.workflowid != null) {
      const workflowId = this.$route.query.workflowid + "";
      this.appData = await this.workflowToAppData(workflowId);
      await this.putWorkflowStep( this.appData.workflowId, "MatchHeadstart") 
      this.saveAppData(this.appData);
    } else {
      this.appData = this.getAppData();
      if (this.appData != null) {
        this.appData.preferredProgram = WORKFLOW_PREFERRED_HEAD_START;
        this.saveAppData(this.appData);
        await this.putWorkflowStep( this.appData.workflowId, "MatchHeadstart") 
        await this.postWorkflowEligible(
          this.appData.workflowId,
          this.appData.preferredProgram
        );
      }
    }

    this.loadDataFinished = true;
  }

  disableNext(): boolean {
    return !this.loadDataFinished;
  }
}
